import type { AxiosError, AxiosResponse } from "axios";
import type { ChatSearchResponse, SearchChatMessagesInput } from "shared";
import { axiosClient } from "utilz";
import { apiErrorHandler } from "utilz/helpers";

const BASE_URL = import.meta.env.VITE_APP_CHAT_BASE_URL;

export const searchChatMessages = async ({
  serviceType,
  serviceId,
  query,
  threadId,
  page = 1,
  limit = 20,
}: SearchChatMessagesInput): Promise<ChatSearchResponse> => {
  try {
    const url = `${BASE_URL}/api/messages/v2/search/${serviceType}/${serviceId}?q=${encodeURIComponent(query)}&page=${page}&limit=${limit}${threadId ? `&thread_id=${threadId}` : ""}`;
    const response = await axiosClient.get(url);
    const resData = response.data;
    if (resData.success) {
      return resData;
    }
    throw response;
  } catch (error) {
    return apiErrorHandler(error as AxiosError | AxiosResponse);
  }
};
